require('./_wks-define')('asyncIterator');


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 433
// module chunks = 2 92